import Vue from 'vue';
import VueRouter, { RawLocation, Route, RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'FirebaseLogin',
    component: () => import('../views/FirebaseLogin.vue'),
  },
  {
    path: '/userpages',
    name: 'UserPages',
    component: () => import('../views/UserPages.vue'),
    children: [
      {
        path: '/personalHomepage',
        name: 'PersonalHomepage',
        component: () => import('../views/PersonalHomepage.vue'),
      },
      {
        path: '/afterSubmit',
        name: 'AfterSubmit',
        component: () => import('../views/AfterSubmit.vue'),
      },
      {
        path: '/form',
        name: 'Form',
        component: () => import('../views/Form.vue'),
        children: [
          {
            path: 'personalInformation',
            name: 'PersonalInformation',
            component: () => import('../components/PersonalInformation.vue'),
          },
          {
            path: 'longevity',
            name: 'Longevity',
            component: () => import('../components/Longevity.vue'),
          },
          {
            path: 'prayFor',
            name: 'PrayFor',
            component: () => import('../components/PrayFor.vue'),
          },
          {
            path: 'attendInfo',
            name: 'AttendInfo',
            component: () => import('../components/AttendInfo.vue'),
          },
          {
            path: 'checkForm',
            name: 'CheckForm',
            component: () => import('../components/CheckForm.vue'),
          },
        ],
      },
      {
        path: '/successful',
        name: 'Successful',
        component: () => import('../views/Successful.vue'),
      },
      {
        path: '/saveOnly',
        name: 'SaveOnly',
        component: () => import('../views/SaveOnly.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: RawLocation): Promise<Route> {
  return new Promise((resolve, reject) => {
    originalPush.call(this, location, () => {
      // on complete

      resolve(this.currentRoute);
    }, (error) => {
      // on abort

      // only ignore NavigationDuplicated error
      if (error.name === 'NavigationDuplicated') {
        resolve(this.currentRoute);
      } else {
        reject(error);
      }
    });
  });
};

export default router;
